import ContactForm from "@/components/ContactForm";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import "@/styles/ContactPage.css";

const ContactPage = () => {
  return (
    <div className="contact-page" data-testid="contact-page">
      <div className="contact-hero">
        <div className="container">
          <h1 className="contact-title fade-in-up" data-testid="contact-title">Contáctanos</h1>
          <p className="contact-subtitle fade-in-up" data-testid="contact-subtitle">
            Estamos listos para hacer realidad tu próximo proyecto
          </p>
        </div>
      </div>

      <div className="container section-padding">
        <div className="contact-content">
          <div className="contact-info" data-testid="contact-info">
            <h2>Información de Contacto</h2>
            <p className="info-description">
              Comunícate con nosotros y te responderemos lo antes posible. Estamos comprometidos con la excelencia en cada proyecto.
            </p>

            <div className="info-items">
              <div className="info-item" data-testid="contact-phone-info">
                <div className="info-icon">
                  <Phone size={24} />
                </div>
                <div>
                  <h3>Teléfono</h3>
                  <p>829-993-0555</p>
                </div>
              </div>

              <div className="info-item" data-testid="contact-email-info">
                <div className="info-icon">
                  <Mail size={24} />
                </div>
                <div>
                  <h3>Email</h3>
                  <p>info@pimot.com.do</p>
                </div>
              </div>

              <div className="info-item" data-testid="contact-location-info">
                <div className="info-icon">
                  <MapPin size={24} />
                </div>
                <div>
                  <h3>Ubicación</h3>
                  <p>República Dominicana</p>
                </div>
              </div>

              <div className="info-item" data-testid="contact-hours-info">
                <div className="info-icon">
                  <Clock size={24} />
                </div>
                <div>
                  <h3>Horario</h3>
                  <p>Lunes - Viernes: 8:00 AM - 6:00 PM</p>
                  <p>Sábado: 8:00 AM - 1:00 PM</p>
                </div>
              </div>
            </div>
          </div>

          <div className="contact-form-container">
            <ContactForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;